// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"cb8cde1a","777":"31d6cfe0"}[chunkId] + ".chunk.css";
};